<template>
  <div class="mx-auto py-4">
    <v-card class="mx-4 my-2" flat>
      <v-card-title>
        Training Detail Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel :data="selected" :fields="export_fields" name="trainingDetailReport.xls" type="csv">
            <v-btn class="teal white--text" color="primary" dark depressed small>
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="trainingSummaryReports.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="trainingSummaryReports.count"
          item-key="id"
          class="elevation-1"
          loading-text="Loading... please wait"
          show-select>
        <template v-slot:top>
          <v-layout class="pb-2 px-4" row wrap>
            <v-flex class="p-2" xs3>
              <v-text-field
                  v-model="filterTrainee"
                  append-icon="mdi-magnify"
                  hide-details
                  label="Name"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs3>
              <v-text-field
                  v-model="phone"
                  hide-details
                  label="Phone Number"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs3>
              <v-autocomplete
                  v-model="cpdProviderId"
                  :clearable="true"
                  :items="CPD_PROVIDERS"
                  :loading="cpdLoading"
                  item-text="trainingCenterName"
                  item-value="id"
                  label="Cpd Provider">
              </v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs3>
                <v-autocomplete
                    v-model="categoryId"
                    :clearable="true"
                    :items="CATEGORIES"
                    :loading="categoryLoading"
                    item-text="name"
                    item-value="id"
                    label="Cpd activity Category">
                </v-autocomplete>
              </v-flex>
            <v-flex class="p-2" xs2>
                <v-autocomplete
                    v-model="cpdActivityId"
                    :clearable="true"
                    :items="CPD_ACTIVITIES"
                    :loading="cpdActLoading"
                    item-text="name"
                    item-value="id"
                    label="Cpd activity">
                </v-autocomplete>
              </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="courseId"
                  :clearable="true"
                  :items="COURSE"
                  :loading="courseLoading"
                  item-text="courseName"
                  item-value="id"
                  label="Course">
              </v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
                <v-autocomplete
                    v-model="statusValue"
                    :clearable="true"
                    :items="STATUS"
                    item-text="name"
                    item-value="id"
                    label="Status">
                </v-autocomplete>
              </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="startDate" :clearable="true" persistent-hint
                                placeholder="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDate"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="endDate" :clearable="true" persistent-hint
                                placeholder="End Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="endDate"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-switch class="p-2 black--text" xs2 v-model="isEmployeeValue" :label="
        `${isEmployeeValue == true
          ? 'Employee'
          : 'Non-Employee'
        }`
      " ></v-switch>
          </v-layout>
        </template>
        <template v-slot:[`item.trainee.fullName`]="{ item }">
          <label for="item">
            {{
              item.trainee
                  ? item.trainee.prefix
                      ? item.trainee.prefix
                      : ""
                  : ""
            }}
            {{
              item.trainee
                  ? item.trainee.firstName
                      ? item.trainee.firstName
                      : "-"
                  : "-"
            }}
            {{
              item.trainee
                  ? item.trainee.middleName
                      ? item.trainee.middleName
                      : "-"
                  : "-"
            }}
            {{
              item.trainee
                  ? item.trainee.lastName
                      ? item.trainee.lastName
                      : "-"
                  : "-"
            }}</label
          >
        </template>
        <template v-slot:[`item.trainee.unemployed`]="{ item }">
          <v-chip :color="getColor(!item.trainee.unemployed)" dark>
            {{ item.trainee.unemployed?'No':'Yes' }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {TrainingSummaryService} from "./training-summary-service";
import {getCategories} from "@/utils/helper";
import {TraineeService} from "../../Trainees/trainees.service";
import {LookupService} from "../../../common/api.service";
import {getProgramsDrp} from "../../../utils/helper";

export default {
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
      },

      CATEGORIES: [],
      CPD_ACTIVITIES: [],
      STATUS: [],
      COURSE: [],
      CPD_PROVIDERS: [],
      cpdActLoading: false,
      categoryLoading: false,
      statusLoading: false,
      cpdLoading: false,
      courseLoading: false,

      filterTrainee: null,
      startDate: null,
      endDate: null,
      cpdActivityId: null,
      categoryId: null,
      statusValue: null,
      cpdProviderId: null,
      courseId: null,
      phone: null,
      isEmployeeValue: null,

      traineStatusIds: {passId: "", failId: ""},
      traineeStatus: [],

      trainingSummaryReports: [],
      headers: [
        {text: "Full Name", value: "trainee.fullName"},
        {text: "Phone Number", value: "trainee.phoneNumber"},
        {text: "Gender", value: "trainee.gender"},
        {text: "Employee", value: "trainee.unemployed"},
        {text: "Profession", value: "trainee.healthProfession.name"},
        {text: "Facility Name", value: "trainee.facility.name"},
        {text: "CPD Activity Category", value: "new_trainees_course.program.category.name"},
        {text: "Course", value: "new_trainees_course.course.courseName"},
        {text: "CEU", value: "new_trainees_course.course.continualEducationUnit"},
        {text: "CPD Provider", value: "new_trainees_course.program.cpdProvider.trainingCenterName"},
        {text: "Training Start Date", value: "new_trainees_course.program.startDate"},
        {text: "Training End Date", value: "new_trainees_course.program.endDate"},
      ],
      export_fields: {
        "Full Name": {
          field: "trainee",
          callback: (value) => {
            return value
                ? value.firstName + " " + value.middleName + " " + value.lastName
                : null;
          },
        },
        "Phone Number": "trainee.phoneNumber",
        "Gender": "trainee.gender",
        "Employee": "trainee.unemployed",
        "Profession": "trainee.healthProfession.name",
        "Facility Name": "trainee.facility.name",
        "CPD Activity Category": "new_trainees_course.program.category.name",
        "Course": "new_trainees_course.course.courseName",
        "CEU": "new_trainees_course.course.continualEducationUnit",
        "CPD Provider": "new_trainees_course.program.cpdProvider.trainingCenterName",
        "Training Start Date": "new_trainees_course.program.startDate",
        "Training End Date": "new_trainees_course.program.endDate"
      },

      loading: false,
      clearable: true,
      selected: [],
    }
  },
  async beforeMount() {
    this.initLookups();
  },
  watch: {
    options: {
      handler() {
        this.fetchTSummaryReports();
      },
      deep: true,
    },
    search(val) {
      if (this.select && this.items.length > 0) return;
      val && val !== this.select && this.querySelections(val);
      if (val === null) {
        this.traineeNotFound = false;
      }
    },
    filterTrainee: function (val) {
      this.filterTrainee = val;
      this.fetchTSummaryReports();
    },
    startDate: function (val) {
      this.startDate = val;
      this.fetchTSummaryReports();
    },
    endDate: function (val) {
      this.endDate = val;
      this.fetchTSummaryReports();
    },
    categoryId: function (val) {
      this.categoryId = val;
      this.fetchCpdActivity(this.categoryId);
      this.fetchTSummaryReports();
    },
    cpdActivityId: function (val) {
      this.cpdActivityId = val;
      this.fetchTSummaryReports();
    },
    statusValue: function (val) {
      this.statusValue = val;
      this.fetchTSummaryReports();
    },
    phone: function (val) {
      this.phone = val;
      this.fetchTSummaryReports();
    },
    cpdProviderId: function (val) {
      this.cpdProviderId = val;
      this.fetchTSummaryReports();
    },
    courseId: function (val) {
      this.courseId = val;
      this.fetchTSummaryReports();
    },
    isEmployeeValue: function (val) {
      this.isEmployeeValue = val;
      this.fetchTSummaryReports();
    },
  },
  methods: {
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
    async initLookups() {
      this.categoryLoading = true;
      this.CATEGORIES = await getCategories();
      this.categoryLoading = false;
      this.courseLoading = true;

      this.fetchTSummaryReports();
      this.fetchCpdActivity();
      this.fetchTraineeStatus();
      this.fetchCpdProviders();
      this.fetchCourses();
    },
    async fetchCpdActivity(id = null) {
      this.cpdActLoading = true;
      const programs = await getProgramsDrp(id);
      this.CPD_ACTIVITIES = programs.data;
      this.cpdActLoading = false;
    },
    async fetchCpdProviders() {
      this.cpdLoading = true;
      const res = await TrainingSummaryService.getTrainingCentersDrp();
      console.log(res)
      this.CPD_PROVIDERS = res?.data;
      this.cpdLoading = false;
    },
    async fetchCourses() {
      this.courseLoading = true;
      const course = await LookupService.getCourses();
      this.COURSE = course?.data?.data;
      this.courseLoading = false;
    },
    async fetchTraineeStatus() {
      this.statusLoading = true;
      this.traineeStatus = await TraineeService.getTraineeStatus();
      this.STATUS = [...this.traineeStatus.data, {name: 'Un Completed', id: 0}];
      this.statusLoading = false;
      this.traineeStatus.data.filter((e) => {
        this.traineStatusIds.passId =
            e.code == "PASS" ? e.id : this.traineStatusIds.passId;
        this.traineStatusIds.failId =
            e.code == "FAIL" ? e.id : this.traineStatusIds.failId;
      });
    },
    async fetchTSummaryReports() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      this.filterTrainee !== null && (params += '&name=' + this.filterTrainee);
      this.startDate !== null && (params += '&startDate=' + this.startDate);
      this.endDate !== null && (params += '&endDate=' + this.endDate);
      this.categoryId !== null && (params += '&categoryId=' + this.categoryId);
      this.cpdActivityId !== null && (params += '&cpdActivityId=' + this.cpdActivityId);
      this.statusValue !== null && (params += '&statusId=' + this.statusValue);
      this.phone !== null && (params += '&phone=' + this.phone);
      this.cpdProviderId !== null && (params += '&cpdId=' + this.cpdProviderId);
      this.courseId !== null && (params += '&courseId=' + this.courseId);
      this.isEmployeeValue !== null && (params += '&isEmployed=' + !this.isEmployeeValue);
      const res = await TraineeService.getNewTraineeAssignList(params);
      if (res.status === 200) {
        this.loading = false;
        this.trainingSummaryReports = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching training detail reports, Please try Again!"
        );
      }
    },
  },
};
</script>
